<p-fieldset legend="Schule">
  <div class="flex flex-col gap-4">
    <p>Bitte lediglich den höchsten (bisher) erreichten Schulabschluss angeben.</p>
    <div class="flex flex-col gap-4">
      <p-floatlabel variant="on">
        <input id="Name der Schule" type="text" fluid pInputText appTrTrim [formControl]="schuleFormGroup!.controls.name" />
        <label for="Name der Schule">Name der Schule*</label>
      </p-floatlabel>

      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row items-start gap-y-8 md:gap-x-4">
          <p-floatlabel class="w-full" variant="on">
            <p-select
              inputId="angestrebterAbschluss"
              [formControl]="schuleFormGroup!.controls.abschluss"
              [options]="graduations"
              [optionValue]="'value'"
              dropdownIcon="pi-angle-down"
              optionLabel="value"
              (onChange)="schoolGradChange($event)"
              fluid
            />
            <label for="angestrebterAbschluss">(Angestrebter) Abschluss</label>
          </p-floatlabel>
          <div class="w-full">
            <p-floatlabel variant="on">
              <p-datePicker
                id="schulEnde"
                [formControl]="schuleFormGroup!.controls.ende"
                [showIcon]="true"
                [showClear]="true"
                iconDisplay="input"
                fluid
                dateFormat="dd.mm.yy"
              />
              <label for="schulEnde">Beendigung der Schule</label>
            </p-floatlabel>
            <small class="form-hint-text">Leer lassen, wenn noch nicht abgeschlossen</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-end items-end pt-2">
    <p-button severity="danger" outlined type="button" (click)="remove.emit()" icon="pi pi-trash" label="Löschen"></p-button>
  </div>
</p-fieldset>
